import * as React from "react";
import { Grid } from "@mui/material";

export enum SidebarSide {
  Right,
  Left,
}

type SidebarLayoutProps = React.PropsWithChildren<{
  sideBar?: React.ReactNode;
  side?: SidebarSide; // Defaults to right
  hideTopDivider?: boolean;
  hideSidebarDivider?: boolean;
  showSidebarContent?: boolean;
}>;

const SidebarLayout = (props: SidebarLayoutProps) => {
  const sidebarSide = props.side ? props.side : SidebarSide.Right;
  const mainContentSize = props.showSidebarContent ? 10 : 12;

  return (
    <Grid container spacing={2}>
      {sidebarSide === SidebarSide.Left && renderSidebar(props)}
      <Grid size={mainContentSize}>{props.children}</Grid>
      {sidebarSide === SidebarSide.Right && renderSidebar(props)}
    </Grid>
  );
};

function renderSidebar(props: SidebarLayoutProps) {
  if (!props.sideBar || !props.showSidebarContent) {
    return null;
  }
  return <Grid size={2}>{props.sideBar}</Grid>;
}

export default SidebarLayout;
